<template>
    <div class="time-change-way-wrapper">
        <el-dialog
          :visible.sync="showClassInfo"
          top="13vh"
          width="800px"
          :title="time_change_way === 'periods' ? '计划开班期数详情' : '计划开班月份详情'"
          class=" detail-info-dia"
        >
            <div class="scrollAreaPeriods">
                <vue-scroll :ops="vuescrollOpt" ref="vScroll">
                    <div class="InfoWrap">
                        <div class="classInfo" v-if="time_change_way === 'periods'">
                            <div class="row"  v-for="(item, index) in dataPhase" :key="index">
                                <div class="col" v-if="item.start_date_two == item.start_date && item.end_date_two == item.end_date">
                                    <p v-if="item.start_date_two">选择{{index+1}}（阶段一：{{ item.start_date | time(false, true) }} 至 {{item.end_date | time(false, true) }} <span v-if="item.province_name">，{{item.province_name}}{{item.city_name}}</span>）</p>
                                </div>
                                <div class="col" v-else>
                                    <p v-if="item.start_date_two">选择{{index+1}}（阶段一：{{ item.start_date | time(false, true) }} 至 {{item.end_date | time(false, true) }}，阶段二： {{ item.start_date_two | time(false, true) }} 至 {{ item.end_date_two | time(false, true) }} <span v-if="item.province_name">，{{item.province_name}}{{item.city_name}}</span>）</p>
                                    <p v-else>选择{{index+1}}（阶段一：{{ item.start_date | time(false, false) }}，阶段二： {{ item.end_date | time(false, false) }}<span v-if="item.province_name">，{{item.province_name}}{{item.city_name}}</span>）</p>
                                </div>
                            </div>
                        </div>
                        <div class="classInfo" v-if="time_change_way === 'month'">
                            <div class="row"  v-for="(item, index) in dataPhase" :key="index">
                                <div class="col">
                                    <p>{{ item.start_date | time(false, false) }} 至 {{ item.end_date | time(false, false) }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </vue-scroll>
            </div>
        </el-dialog>
    </div>
    
</template>

<script>
    import {area_name} from "@/assets/js/region";
    import createScrollOpt from "@/assets/js/vuescrollOption";
    export default {
        name: "classInfoDetail",
        props:{
            isShow:{
                type:Boolean,
                required:true,
                default:false,
            },
          time_change_way:{
            type: String,
            required: true,
          },
            dataPhase:{
              type:Array,
              required: true,
            }
        },
      data() {
        return {
          vuescrollOpt: createScrollOpt(true),
        }
      },
        computed:{
            showClassInfo:{
                get(){
                    return this.isShow;
                },
                set(val){
                  this.$emit('update:isShow',val)
                },
            }
        },
        filters:{
            getArea(id) {
                return area_name[id];
            },
        }
    }
</script>

<style  lang="stylus">
    @import '~@/assets/css/variable';
.time-change-way-wrapper
  .el-dialog__body
     padding: 20px 0 20px 20px;
  .scrollAreaPeriods
    height 300px
    .InfoWrap {
        .classInfo {
            font-size: 15px
            margin-bottom 5px
            margin-right: 20px;
            border: 1px solid #606266;
            .row {
                height: 40px;
                display: flex;
                align-items: center;
                border-bottom: 1px solid #606266;
                .col {
                    flex: 1 0 auto;
                    display: flex;
                    .tip {
                        margin: 0 0 0 30px;
                    }
                }
                .col:first-child {
                    width: 45%;
                    padding: 0 0 0 10px;
                }
                .col:last-child {
                    width: 55%;
                }
            }
            .row:last-child {
                border-bottom: none;
            }
        }
    }
</style>
